import { useAuth } from "@allergy123/auth-client/react";
import { Button, Container, DraftBanner, SiteFooter, SiteHeader } from "@allergy123/ui";
import type { ReactNode } from "react";
import { NavLink, useLocation } from "react-router";

export function AdminShell({ children }: { children: ReactNode }) {
  const { session, signOut } = useAuth();
  const { pathname } = useLocation();
  const inCatalog = pathname === "/catalog" || pathname.startsWith("/catalog/");
  // `active` overrides the link's own match, so one top-bar entry can stand for a whole section.
  const link = (to: string, label: string, active?: boolean) => (
    <NavLink to={to} className={({ isActive }) => ((active ?? isActive) ? "font-semibold text-anchor" : undefined)}>
      {label}
    </NavLink>
  );
  return (
    <div className="min-h-screen bg-canvas">
      {import.meta.env.MODE !== "production" && <DraftBanner>Development build — synthetic staff sign-in against the local API unless AUTH_* is set.</DraftBanner>}
      <SiteHeader
        logoVariant="auto"
        nav={
          <>
            {link("/organizations", "Organizations")}
            {link("/catalog/panels", "Catalog", inCatalog)}
            {link("/orders", "Orders")}
            {link("/learners", "Learners")}
            {link("/invite", "Invite")}
            {link("/audit", "Audit")}
            {link("/security", "Security")}
          </>
        }
        actions={
          <>
            <span className="text-small text-ink-secondary">{session?.claims.email} · staff</span>
            <Button variant="secondary" onClick={() => void signOut()}>
              Sign out
            </Button>
          </>
        }
      />
      <main>
        <Container className="py-12">{children}</Container>
      </main>
      <SiteFooter />
    </div>
  );
}
